import React from 'react';
import PropTypes from 'prop-types';

export const Breadcrumb = (props) => (
  <div className="gallery__breadcrumb-wrapper">
    {props.path.map((p, index) => (
      <React.Fragment key={`breadcrumb_path_piece_${p.text.toLowerCase().replaceAll(' ', '_')}`}>
        <a
          className="gallery__breadcrumb paragraph3"
          href={p.href}
          data-qa-id={`galleryBreadCrumb_${p.text.replaceAll(' ', '_')}`}
        >
          {p.text}
        </a>
        {index < props.path.length - 1 && <span>/</span>}
      </React.Fragment>
    ))}
  </div>
);

Breadcrumb.propTypes = {
  path: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
};
